import "../styles/LegalPages.css";

function ResponsibleGamingPage() {

  return (

    <div className="legal-page">

      <div className="legal-container">

        <h1>

          Jeu responsable

        </h1>

        <div className="legal-danger">

          <h3>

            Avertissement important

          </h3>

          <p>

            Les pronostics proposés sur FootVision Live ne garantissent jamais un résultat.

          </p>

        </div>

        <section>

          <h2>

            Notre engagement

          </h2>

          <p>

            FootVision Live fournit uniquement des analyses sportives, des statistiques, des compositions et des pronostics à titre informatif.

            Nous n'encourageons jamais les jeux d'argent excessifs.

          </p>

        </section>

        <section>

          <h2>

            Votre responsabilité

          </h2>

          <p>

            Chaque utilisateur reste seul responsable de ses décisions.

            Toute perte financière résultant d'un pari sportif est entièrement à la charge de l'utilisateur.

            FootVision Live ne peut être tenu responsable des conséquences financières liées aux paris.

          </p>

        </section>

        <section>

          <h2>

            Conseils

          </h2>

          <ul>

            <li>Ne pariez jamais plus que ce que vous pouvez perdre.</li>

            <li>Ne considérez jamais les paris comme une source de revenus.</li>

            <li>Faites régulièrement des pauses.</li>

            <li>Respectez les lois de votre pays.</li>

            <li>Si vous pensez développer une dépendance, demandez de l'aide auprès d'un organisme spécialisé.</li>

          </ul>

        </section>

      </div>

    </div>

  );

}

export default ResponsibleGamingPage;